module.exports = __webpack_public_path__ + "img/wake-logo-dark.87faf778.png";